// Single source of truth for the backend API base URL.
//
// Resolution order (first match wins):
//   1. Explicit override via `process.env.API_URL`. Inlined into the client
//      bundle by webpack DefinePlugin (see webpack.client.js) and read at
//      runtime on the server (set per-deploy in PM2, or per-session for a cloud
//      dev agent). Empty string when unset.
//   2. Browser: derived from `window.location.hostname`.
//   3. Server (SSR): from the incoming request Host header when provided,
//      otherwise a NODE_ENV-based dev default.

const LOCAL = 'http://0.0.0.0:8000';
const STAGING = 'https://staging-api.roulezjeunesse.com';
const PROD = 'https://api.roulezjeunesse.com';

export function getApiBaseUrl(requestHost) {
  // 1. Explicit override (DefinePlugin client-side / env var server-side).
  if (process.env.API_URL) return process.env.API_URL;

  // 2. Browser: detect from the current host.
  if (typeof window !== 'undefined' && window.location) {
    const { hostname } = window.location;
    if (hostname === 'localhost' || hostname === '0.0.0.0') return LOCAL;
    if (hostname === 'staging.roulezjeunesse.com') return STAGING;
    return PROD;
  }

  // 3a. Server, request-scoped: pick by the incoming SSR request Host header.
  if (requestHost !== undefined) {
    return String(requestHost).includes('staging') ? STAGING : PROD;
  }

  // 3b. Server, static: NODE_ENV-based dev default.
  if (
    typeof process !== 'undefined' &&
    process.env &&
    process.env.NODE_ENV !== 'production'
  ) {
    return LOCAL;
  }
  return PROD;
}

// Resolved base for the current runtime, no request context.
export const API_BASE_URL = getApiBaseUrl();

// For endpoints previously pinned to production: honour the override, otherwise
// keep hitting production exactly as before (no host-based detection).
export const API_BASE_URL_OR_PROD = process.env.API_URL || PROD;
